import Vue from "vue";

import mains from "@/boilerplate/app.main.mjs";

Object.values(mains).forEach((main) => {
    main();
});
